import * as d3Color from 'd3-color'

// Returns text color based on background color
export default function setTextColorWithBackground({
    r,
    g,
    b,
}: d3Color.RGBColor) {
    // TODO: THIS CHANGED, was it safe to do so?
    const color = Math.round((r * 299 + g * 587 + b * 114) / 1000)

    return color > 125 ? '#000' : '#fff'
}
